import { userHasConsentedToPreferences } from "@/utils/cookie-permissions";
import { store } from "../utils";

export function getSelectedLocale(): string | null {
  return store.get("locale") ?? null;
}

export function setSelectedLocale(locale: string) {
  if (userHasConsentedToPreferences()) {
    store.set("locale", locale);
  }
}
